import {
  IonButton,
  IonButtons,
  IonCol,
  IonGrid,
  IonImg,
  IonInput,
  IonLabel,
  IonList,
  IonRow,
  IonSelect,
  IonSelectOption,
} from '@ionic/react';
import classNames from 'classnames';
import dayjs from 'dayjs';
import { chevronDownOutline } from 'ionicons/icons';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import ArrowImg from '@/assets/icons/arrow.svg';
import BankCard from '@/assets/icons/bank-card.svg';
import CreditCard from '@/assets/icons/credit-card.svg';
import EditIcon from '@/assets/icons/edit-icon.svg';
import EntryImg from '@/assets/imgs/entry-shop.svg';
import EuroImg from '@/assets/imgs/euro-icon.svg';
import { AnalyticsOrigination, AnalyticsStepNumber } from '@/interfaces/AnalyticsInterface/AnalyticsInterface';
import { EDNIModalRoutes } from '@/interfaces/EDniModalInterface/EDniModalInterface';
import { getSimulations } from '@/redux/eDniModal/eDniModalAPI';
import {
  CommercialOfferType,
  LoanSimulation,
  PaymentMethods,
} from '@/redux/eDniModal/eDniModalInterface';
import { saveLoanSimulation } from '@/redux/eDniModal/loanSimulation/loanSimulation';
import { saveProduct } from '@/redux/eDniModal/product/product';
import {
  CommercialOffer,
  GoodTypes,
  Merchant,
} from '@/redux/operation/operationsInterface';
import {
  getTimeResult,
  registerBeginTransaction,
  registerEntryContinue,
  registerSimulation,
  registerSimulationChange,
  registerSimulationEdit,
} from '@/services/analytics';
import { RootState } from '@/store';
import { pricesHelper } from '@/utils/pricesHelper';

import styles from './Entry.module.scss';

interface EntryProps {
  nextStep: (arg0: EDNIModalRoutes) => void;
  handleLoading: (arg0: boolean) => void;
}

export default function Entry({
  nextStep,
  handleLoading,
}: EntryProps) {
  const dispatch = useDispatch();
  const [merchantData, setMerchantData] = useState<Merchant | null>(null);
  const [productSelected, setProductSelected] = useState<GoodTypes | null>(
    null,
  );
  const [amount, setAmount] = useState<string | null>('');
  const [amountError, setAmountError] = useState<string>('');
  const [commercialOffersList, setCommercialOffersList] = useState<
    CommercialOfferType[] | null
  >(null);
  const [inputAmount, setInputAmount] = useState('');
  const [termOptionsList, setTermOptionsList] = useState<any | null>(null);
  const [term, setTerm] = useState<number | null>();
  const [commercialOfferSelected, setCommercialOfferSelected] = useState<CommercialOfferType | null>(null);
  const [commercialOffersFiltered, setCommercialOffersFiltered] = useState<any>();
  const [commercialOffersDisplayed, setCommercialOffersDisplayed] = useState<any>();
  const [simulationSelected, setSimulationSelected] = useState<LoanSimulation | null>(null);
  const [showSummary, setShowSummary] = useState<boolean>(false);
  const [showBtn, setShowBtn] = useState<boolean>(false);
  const [upArrowDisabled, setUpArrowDisabled] = useState<boolean>(false);
  const [initTime] = useState<dayjs.Dayjs>(dayjs());
  const [bottomArrowDisabled, setBottomArrowDisabled] = useState<boolean>(false);
  const [storageOffers, setStorageOffers] = useState<CommercialOffer[]>([]);
  const [hideTermList, setHideTermList] = useState<boolean>(true);

  const merchantInfo = useSelector(
    (state: RootState) => state.merchantData.data,
  );

  const blockCharacters = (event: any) => ['e', 'E', '+', '-'].includes(event.key) && event.preventDefault();

  const getProducts = () => {
    if (merchantInfo) {
      const product = merchantInfo.good_types[0];
      setMerchantData(merchantInfo);
      setProductSelected(product);
    }
  };

  const changeProductInput = (e: any) => {
    const selection = merchantData?.good_types
      && merchantData.good_types.find(
        (pr: GoodTypes) => pr.name === e.detail.value,
      );
    selection && setProductSelected(selection);
  };


  useEffect(() => {
    if (inputAmount) {
      setAmountError('');
      const data = setTimeout(() => {
        if (amount === inputAmount) {
          setHideTermList(false);
        }
        setAmount(inputAmount);
      }, 800);
      return () => clearTimeout(data);
    }
  }, [inputAmount]);

  const changeAmountInput = (e: any) => {
    setHideTermList(true);
    if (e.target.value) {
      setInputAmount(e.target.value);
    } else {
      setHideTermList(true);
      setAmountError('Introduce un importe válido');
    }
  };

  const getLoanSimulation = async (termSelected: any) => {
    if (amount) {
      try {
        const amountT = parseFloat(amount);
        termSelected = termSelected && parseInt(termSelected);
        const sim = {
          amount: amountT,
          flows: ['CEX', 'PLS', 'SUS'],
          term: termSelected,
        };
        const commercialOffers = (await getSimulations(sim)).data
          .commercial_offers;
        setCommercialOffersList(commercialOffers);
        // handleSelection(commercialOffers.data.commercial_offers);
        // if (commercialOffersList && commercialOffersList.length > 0) {
        const newTerm = parseInt(termSelected);
        setTerm(newTerm);
        const filteredList: CommercialOfferType[] = [];
        const offersList = [...commercialOffers];
        offersList?.forEach((elem: CommercialOfferType) => {
          const filteredF = elem.financial_offers.filter(
            (offer: any) => newTerm === offer.term,
          );
          const newElem = elem;
          newElem.financial_offers = [...filteredF];
          if (newElem.financial_offers.length > 0) {
            filteredList.push(newElem);
          }
        });
        setCommercialOffersFiltered(filteredList);
        if (filteredList.length > 3) {
          const shownOffers = filteredList.slice(0, 3);
          setCommercialOffersDisplayed(shownOffers);
          setBottomArrowDisabled(false);
          setUpArrowDisabled(true);
        } else {
          setCommercialOffersDisplayed(filteredList);
          setUpArrowDisabled(true);
          setBottomArrowDisabled(true);
        }
        filteredList[0] && setCommercialOfferSelected(filteredList[0]);
        let selection;
        if (filteredList[0]) {
          [selection] = filteredList;
        }
        if (selection) {
          //   InsightService.logTrace("LoanSimulation", [
          //     { commercialOfferId: selection?.commercial_offer_id },
          //     { amount: selection.financial_offers[0].total_cost.toString() },
          //     { term: selection.financial_offers[0].term.toString() },
          //   ]);
          setSimulationSelected(selection.financial_offers[0]);
          const simulationAnalytics = {
            simulation_amount: amountT || 0,
            simulation_max_term: termOptionsList ? termOptionsList[termOptionsList.length - 1] : '',
            simulation_min_term: termOptionsList ? termOptionsList[0] : '',
            simulation_term_count: termOptionsList ? termOptionsList.length : 0,
            simulation_term: termSelected || 0,
            simulation_offer_count: selection ? selection?.financial_offers?.length : 0,
            simulation_cex_available: commercialOffers ? commercialOffers.some((offer: CommercialOfferType) => offer.flow === 'CEX') : false,
            simulation_sus_available: commercialOffers ? commercialOffers.some((offer: CommercialOfferType) => offer.flow === 'SUS') : false,
            simulation_pls_available: commercialOffers ? commercialOffers.some((offer: CommercialOfferType) => offer.flow === 'PLS') : false,
          };
          registerSimulation({ origin: AnalyticsOrigination.App }, simulationAnalytics);
        }
        if (!showBtn) {
          setShowBtn(true);
          setShowSummary(true);
        }
        // }
      } catch (error: any) {
        if (error?.result?.http_code === 401) {
          nextStep(EDNIModalRoutes.TIMEOUT);
          handleLoading(false);
        } else {
          nextStep(EDNIModalRoutes.UNKNOWN_ERROR);
          handleLoading(false);
        }
      }
    }
  };

  const selectCommercialOffer = (selectedId: string) => {
    const offerSelected = commercialOffersFiltered?.find(
      (offer: CommercialOfferType) => offer.commercial_offer_id === selectedId,
    );
    if (offerSelected) {
      setCommercialOfferSelected(offerSelected);
      setSimulationSelected(offerSelected.financial_offers[0]);
      registerSimulationChange({ origin: AnalyticsOrigination.App });
    }
  };

  const resetSimulation = () => {
    registerSimulationEdit({ origin: AnalyticsOrigination.App });
    setSimulationSelected(null);
    // setAmount(null);
    // setTerm(null);
    setCommercialOffersList([]);
    setCommercialOffersFiltered([]);
    setCommercialOffersDisplayed([]);
    // setHideTermList(true);
    setShowSummary(false);
  };

  useEffect(() => {
    if (!showSummary && amount) {
      document.getElementById('amount-input')?.setAttribute('value', amount);
    }
  }, [showSummary]);

  const getNewSimulation = async (amountSelected: string) => {
    try {
      setCommercialOffersList([]);
      setAmountError('');
      setHideTermList(false);
      const amountT = parseFloat(amountSelected);
      let termsL: number[] = [];
      storageOffers?.forEach((e) => {
        if (e.max_amount >= amountT && e.min_amount <= amountT) termsL.push(e.term);
      });
      termsL.sort((a, b) => a - b);
      termsL = [...new Set(termsL)];
      setTermOptionsList(termsL);
      if (!termsL || termsL.length === 0) {
        setAmountError('Introduce otro importe');
        setHideTermList(true);
        // setStartTransition(false);
      } else {
        setHideTermList(false);
      }
    } catch (error: any) {
      if (error?.result?.http_code === 401) {
        nextStep(EDNIModalRoutes.TIMEOUT);
        handleLoading(false);
      } else {
        nextStep(EDNIModalRoutes.UNKNOWN_ERROR);
        handleLoading(false);
      }
    }
  };

  const handleContinue = () => {
    if (showSummary) {
      if (simulationSelected && productSelected) {
        simulationSelected.commercial_offer_id = commercialOfferSelected?.commercial_offer_id;
        simulationSelected.commercial_offer_name = commercialOfferSelected?.commercial_offer_name;
        simulationSelected.flow = commercialOfferSelected?.flow;
        simulationSelected.first_due_date = commercialOfferSelected?.first_due_date;
        dispatch(saveLoanSimulation(simulationSelected));
        dispatch(saveProduct(productSelected));
        /*         if (simulationSelected.flow === 'PLS' || simulationSelected.flow === 'SUS') {
                  handleSkip(simulationSelected, productSelected);
                } else { */
        if (simulationSelected) {
          const simulationAnalytics = {
            time_elapsed: initTime ? getTimeResult(initTime) : 0,
            simulation_amount: simulationSelected.financed_amount || 0,
            simulation_term: simulationSelected.term || 0,
            simulation_tae: simulationSelected.tae || 0,
            simulation_tin: simulationSelected.tin || 0,
            simulation_regular_fee: simulationSelected.regular_fee || 0,
            simulation_first_fee: simulationSelected.first_fee || 0,
            simulation_total_cost: simulationSelected.total_cost || 0,
            simulation_opening_fee: simulationSelected.opening_fee || 0,
            simulation_opening_fee_type: simulationSelected.opening_fee_type || '',
            simulation_flow: simulationSelected.flow || '',
            step_number: AnalyticsStepNumber.Simulation,
          };
          const checkoutAnalytics = {
            currency: 'EUR',
            value: simulationSelected.financed_amount || 0,
            items: {
              item_id: simulationSelected.commercial_offer_id || '',
              item_name: commercialOfferSelected?.commercial_offer_name || '',
            },
          };
          registerEntryContinue({ origin: AnalyticsOrigination.App }, simulationAnalytics);
          registerBeginTransaction({ origin: AnalyticsOrigination.App }, checkoutAnalytics);
        }
        nextStep(EDNIModalRoutes.DNI_SCAN);
      }
    } else {
      getLoanSimulation(term);
    }
  };

  const handleTopArrow = () => {
    // true -> desactivar, false -> activar. Ejemplos: RED67674 / DNT60166. 8000 - 60 cuotas = 5 y 2000 - 30 cuotas = 3 y 2500 - 60 cuotas = 5
    if (
      commercialOffersFiltered
      && commercialOffersDisplayed
      && commercialOffersFiltered.length > 3
    ) {
      let firstOfferIndex = commercialOffersFiltered.indexOf(
        commercialOffersDisplayed[0],
      );
      if (firstOfferIndex - 3 >= 0) {
        const shownOffers = commercialOffersFiltered.slice(
          firstOfferIndex - 3,
          firstOfferIndex,
        );
        firstOfferIndex -= 3;
        setCommercialOffersDisplayed(shownOffers);
        if (bottomArrowDisabled) setBottomArrowDisabled(false);
        setUpArrowDisabled(false);
      } else {
        const shownOffers = commercialOffersFiltered.slice(0, 3);
        setCommercialOffersDisplayed(shownOffers);
        if (bottomArrowDisabled) setBottomArrowDisabled(false);
        setUpArrowDisabled(true);
      }
      if (firstOfferIndex === 0) setUpArrowDisabled(true);
      registerSimulationChange({ origin: AnalyticsOrigination.App });
    }
  };

  const handleBottomArrow = () => {
    if (
      !bottomArrowDisabled
      && commercialOffersFiltered
      && commercialOffersDisplayed
      && commercialOffersFiltered.length > 3
    ) {
      const lastOfferIndex = commercialOffersFiltered.indexOf(
        commercialOffersDisplayed?.slice(-1)[0],
      );
      const lastIndexInArray = commercialOffersFiltered.length - 1;
      const newFirstOfferIndex = lastOfferIndex + 1;
      // Comprueba si en las siguientes 3 posiciones hay elementos. Si no, muestra hasta el final del array
      const newLastOfferIndex = commercialOffersFiltered[lastOfferIndex + 3] ? lastOfferIndex + 3 : lastIndexInArray;

      if (newFirstOfferIndex <= lastIndexInArray) {
        const shownOffers = commercialOffersFiltered.slice(
          newFirstOfferIndex,
          newLastOfferIndex + 1,
        );
        setCommercialOffersDisplayed(shownOffers);
        if (upArrowDisabled) setUpArrowDisabled(false);
        if (newLastOfferIndex === lastIndexInArray) setBottomArrowDisabled(true);
        registerSimulationChange({ origin: AnalyticsOrigination.App });
      }
    }
  };

  const isBtnDisabled = () => {
    if (amount && term) {
      return false;
    }
    return true;
  };

  useEffect(() => {
    if (amount) {
      getNewSimulation(amount);
    }
  }, [amount]);

  useEffect(() => {
    if (
      simulationSelected
      && commercialOffersFiltered
      && commercialOffersDisplayed
    ) {
      setShowSummary(true);
    }
  }, [simulationSelected, commercialOffersFiltered, commercialOffersDisplayed]);

  useEffect(() => {
    const offerS = sessionStorage.getItem('pepperSimulationCommercialOffers');
    if (offerS) {
      const parseOffers = JSON.parse(offerS);
      if (parseOffers.length > 0) {
        setStorageOffers(parseOffers);
      }
    }
    getProducts();
    // if (creditProposalResult) {
    //   setAmount(JSON.stringify(creditProposalResult.requested_amount));
    //   creditProposalResult.term && setTerm(creditProposalResult.term);
    // }

    const handleBeforeUnload = () => {
      // Función para limpiar sessionStorage antes de recargar la página
      sessionStorage.removeItem('Product-Type');
    };

    window.addEventListener('beforeunload', handleBeforeUnload);

    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, []);

  return (
    <div className={styles.modalEntryContainer}>
      {!showSummary ? (
        <>
          <div>
            <div className={styles.entryTitleWrapper}>
              <IonLabel className={classNames(styles.modalTitle, styles.modalEntryTitle)}>
                Introduce el producto y el importe para simular la financiación
              </IonLabel>
            </div>
            <IonList lines="full" className={styles.entryForm}>
              <IonSelect
                label="Producto"
                labelPlacement="stacked"
                className={classNames(styles.entryProductInput, styles.upperInput)}
                value={productSelected?.name}
                // selectedText={productSelected?.name}
                interface="popover"
                onIonChange={changeProductInput}
                toggleIcon={chevronDownOutline}
              >
                {merchantData?.good_types
                  && merchantData.good_types.map((product: any) => (
                    <IonSelectOption
                      key={product.code}
                      className={styles.entryProductOption}
                    >
                      {product.name}
                    </IonSelectOption>
                  ))}
              </IonSelect>
              <div className={styles.modalFormRow}>
                <IonInput
                  type="number"
                  label="Importe"
                  id="amount-input"
                  labelPlacement="floating"
                  className={classNames(
                    styles.formAmountInput,
                    {
                      'ion-invalid': amountError,
                      'ion-valid': amountError === '',
                    },
                    !hideTermList
                      ? [styles.formHalfRow, styles.lowerLeftInput]
                      : [styles.formFullRow, styles.lowerInput],
                    styles.lowerInput,
                  )}
                  errorText={amountError}
                  onKeyUp={changeAmountInput}
                  onKeyDown={blockCharacters}
                >
                  <IonImg src={EuroImg} />
                </IonInput>
                {!hideTermList && (
                  <div className={classNames(styles.entryFeesWrapper, styles.formHalfRow)}>
                    <IonSelect
                      label="Plazo"
                      labelPlacement="stacked"
                      className={classNames(styles.entryFeesInput, styles.lowerRightInput)}
                      interface="popover"
                      onIonChange={(e: any) => {
                        if (showBtn) {
                          setTerm(e.detail.value);
                        } else {
                          getLoanSimulation(e.detail.value);
                        }
                      }}
                      value={term}
                    >
                      {termOptionsList
                        && termOptionsList.map((term: any) => (
                          <IonSelectOption
                            key={term}
                            className={styles.entryProductOption}
                            value={term}
                          >
                            {term}
                          </IonSelectOption>
                        ))}
                    </IonSelect>
                    <div className={styles.entryMonthText}>meses</div>
                  </div>
                )}
              </div>
              {amountError && <span className={styles.validationError}>{amountError}</span>}
            </IonList>
          </div>
          <div className={styles.entryImgWrapper}>
            <IonImg src={EntryImg} />
          </div>
        </>
      ) : (
        <div className={styles.modalEntrySummary}>
          <IonLabel className={styles.modalEntryTitle}>
            Introduce los datos para simular la financiación
          </IonLabel>
          <div className={styles.entrySummaryRow}>
            <div className={styles.entryInputsSummary}>
              <div className={styles.summarySimulationData}>
                <IonLabel>Importe solicitado</IonLabel>
                <span>{pricesHelper(Number(amount))}</span>
              </div>
              <div className={styles.summarySimulationData}>
                <IonLabel>Plazo</IonLabel>
                <span>
                  {term}
                  {' '}
                  meses
                </span>
              </div>
            </div>
            <IonImg
              src={EditIcon}
              className={styles.entryEditBtn}
              onClick={() => {
                resetSimulation();
              }}
            />
          </div>
          <div className={styles.templateSelectorWrapper}>
            <IonLabel className={styles.modalEntryTitle}>
              Selecciona la tarifa
            </IonLabel>
            <IonImg
              src={ArrowImg}
              className={classNames(styles.selectorArrowUp, upArrowDisabled && styles.arrowDisabled)}
              onClick={handleTopArrow}
            />
            <IonGrid>
              <IonRow className={styles.entryTemplateGroup}>
                {commercialOffersDisplayed.map((offer: CommercialOfferType) => (
                  <IonCol key={offer.commercial_offer_id}>
                    <div
                      className={classNames(styles.entryTemplate, commercialOfferSelected?.commercial_offer_id
                        === offer.commercial_offer_id && styles.templateSelected)}
                      onClick={() => selectCommercialOffer(offer.commercial_offer_id)}
                    >
                      <IonLabel>{offer.commercial_offer_name}</IonLabel>
                      <div className={styles.entryTemplateImg}>
                        <IonImg
                          src={
                            offer.payment_method === PaymentMethods.CREDIT_CARD
                              ? CreditCard
                              : BankCard
                          }
                        />
                      </div>
                    </div>
                  </IonCol>
                ))}
              </IonRow>
            </IonGrid>
            <IonImg
              src={ArrowImg}
              className={classNames(styles.selectorArrowDown, bottomArrowDisabled && styles.arrowDisabled)}
              onClick={handleBottomArrow}
            />
          </div>
          {simulationSelected && (
            <div className={styles.feesSummary}>
              <div className={styles.feesSummaryBox}>
                <IonRow>
                  <IonCol className={classNames(styles.feeTextWrapper, styles.dateCol)}>
                    <div className={styles.todayHighlight}>
                      {commercialOfferSelected?.flow === 'CEX'
                        || commercialOfferSelected?.flow === 'SUS'
                        ? 'Hoy'
                        : dayjs(
                          commercialOfferSelected?.first_due_date,
                          'YYYY-MM-DD',
                        ).format('DD/MM/YYYY')}
                    </div>
                    <span>Primer pago</span>
                  </IonCol>
                  <IonCol className={classNames(styles.feeTextWrapper, styles.feePriceWrapper)}>
                    <span className={styles.firstFeeQuantity}>
                      {pricesHelper(simulationSelected?.first_fee)}
                    </span>
                  </IonCol>
                </IonRow>
                <IonRow className={styles.regularFeeRow}>
                  <IonCol>
                    <span>
                      Cuotas restantes (
                      {simulationSelected.term - 1}
                      )
                    </span>
                  </IonCol>
                  <IonCol className={styles.feePriceWrapper}>
                    <span>
                      {pricesHelper(simulationSelected.regular_fee)}
                      /mes
                    </span>
                  </IonCol>
                </IonRow>
              </div>
              <span className={styles.openingFeeText}>
                Com. Apertura
                {' '}
                {simulationSelected.opening_fee
                  ? pricesHelper(simulationSelected.opening_fee)
                  : '0,00 €'}
                {simulationSelected.opening_fee ? (
                  <>
                    {simulationSelected.opening_fee_type === 'F'
                      ? ' financiada'
                      : ' primera cuota'}
                    {simulationSelected.opening_fee_type === 'F'
                      && ` (${pricesHelper(
                        simulationSelected.opening_fee / simulationSelected.term,
                      )} por recibo)`}
                  </>
                ) : (
                  ''
                )}
              </span>
            </div>
          )}
        </div>
      )}
      {showBtn && (
        <IonButtons className={styles.nextBtnWrapper}>
          <IonButton
            className="nextButton"
            onClick={handleContinue}
            disabled={isBtnDisabled()}
          >
            Continuar
          </IonButton>
        </IonButtons>
      )}
    </div>
  );
}
